import React, { useState } from 'react';
import { Text, StyleSheet } from 'react-native';
import AdminButton from '../../../Admin/components/AdminButton';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';
import ConfigCheckboxRow from '../components/ConfigCheckboxRow';
import ConfigDrawer from '../components/ConfigDrawer';
import { CONFIG_METRICS } from '../constants';

interface MetricSetDrawerProps {
  org: string;
  dept: string;
  current: string[];
  onClose: () => void;
  onSave: (ids: string[]) => void;
}

/** Chooses which of the fixed metrics this org and department uses. At least one is required. */
const MetricSetDrawer: React.FC<MetricSetDrawerProps> = ({ org, dept, current, onClose, onSave }) => {
  const [selected, setSelected] = useState<string[]>(current);
  const ordered = CONFIG_METRICS.map((m) => m.id).filter((id) => selected.includes(id));
  const dirty = JSON.stringify(ordered) !== JSON.stringify(current);

  return (
    <ConfigDrawer
      title="Choose metrics"
      subtitle={`${org} / ${dept}`}
      onClose={onClose}
      footer={
        <>
          <AdminButton label="Cancel" variant="secondary" onPress={onClose} />
          <AdminButton
            label="Save Metrics"
            variant="primary"
            disabled={!dirty || ordered.length === 0}
            onPress={() => onSave(ordered)}
          />
        </>
      }
    >
      <Text style={styles.note}>
        The metrics this department is measured on. Only these get targets and appear for its employees.
      </Text>
      {CONFIG_METRICS.map((m) => (
        <ConfigCheckboxRow
          key={m.id}
          label={`${m.name}${m.unit ? ` (${m.unit})` : ''}`}
          checked={selected.includes(m.id)}
          onChange={(on) => setSelected(on ? [...selected, m.id] : selected.filter((x) => x !== m.id))}
        />
      ))}
    </ConfigDrawer>
  );
};

const styles = StyleSheet.create({
  note: { fontSize: 12, color: AdminColors.textMuted, fontFamily: FontFamily.regular, marginBottom: 8 },
});

export default MetricSetDrawer;
